import api from './index';

let exports = {};

//询盘list
exports.getDealInqryVoucherList = function (postData, callback) {// 获取询盘单公开列表
    api.post('/deal/inqry/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//定向询盘list
exports.getDealInqryVoucherListByDirected = function (postData, callback) {// 获取定向询盘单列表
    api.post('/deal/inqry/voucher/list/get/by/directed')
    .data(postData)
    .done(callback)
    .go();
};

//询盘单明细
exports.getDealInqryVoucherInfo = function (postData, callback) {// 根据询盘单id查询询盘
    api.post('/deal/inqry/voucher/info/get')
    .data(postData)
    .done(callback)
    .go();
};

//报盘单保存
exports.saveDealReplyVoucher = function (postData, callback) {// 保存报盘单
    api.post('/deal/reply/voucher/save/do')
    .data(postData)
    .done(callback)
    .go();
};

//报盘单list
exports.getDealReplyVoucherList = function (postData, callback) {// 获取报盘单列表
    api.post('/deal/reply/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//报盘单信息
exports.getDealReplyVoucherInfo = function (postData, callback) {// 根据报盘单id查询报盘
    api.post('/deal/reply/voucher/info/get')
    .data(postData)
    .done(callback)
    .go();
};

//报盘单申请
exports.applyDealReplyVoucher = function (postData, callback) {// 申请报盘单
    api.post('/deal/reply/voucher/apply/do')
    .data(postData)
    .done(callback)
    .go();
};

//报盘单审核
exports.auditDealReplyVoucher = function (postData, callback) {// 审核报盘单
    api.post('/deal/reply/voucher/audit/do')
    .data(postData)
    .done(callback)
    .go();
};

//报盘单发布
exports.publishDealReplyVoucher = function (postData, callback) {// 发布报盘单
    api.post('/deal/reply/voucher/publish/do')
    .data(postData)
    .done(callback)
    .go();
};

//修改报盘单tag
exports.updateReplyVoucherTag = function (postData, callback) {// 修改报盘单tag
    api.post('/deal/reply/voucher/tag/update/do')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/deal.js
// module id = 73
// module chunks = 1